import styled from 'styled-components'

import { TypeStyle } from '@syconium/little-miss-figgy'

export const Body = styled(TypeStyle.BodySmall)`
  padding-bottom: 20px;
  position: sticky;
  top: 0;
`

export const Text = styled.span`
  display: inline-block;
  vertical-align: middle;
`

export const AppliedLabel = styled(TypeStyle.HeadlineMicro)`
  align-items: center;
  border: 1px solid ${o => o.theme.color.deprecated.obsidianLighter};
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  margin: 2px;
  padding: 5px 10px;
  white-space: nowrap;
  &:hover {
    background-color: ${o => o.theme.color.deprecated.stoneLight};
  }
`

export const LabelText = styled(Text)`
  padding: 0 5px;
`

export const ClearAll = styled(AppliedLabel)`
  cursor: pointer;

  &:hover {
    background-color: ${o => o.theme.color.deprecated.stoneLight};
  }
`

export const AppliedLabelWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const CloseWrap = styled.span`
  padding-top: 3px;
  padding-left: 5px;
`
